<template>
  <b-form-input :value="lastValue" :placeholder="placeholder" @input="handleInput" />
</template>

<style lang="scss" scoped>
</style>

<script>

export default {
  name: "InputDelay",
  props: {
    value: {
      type: String,
      default: null
    },
    delay: {
      type: Number,
      default: 1000
    },
    placeholder: {
      type: String,
      default: "Поиск..."
    }
  },
  data() {
    return {
      lastValue: this.value,
      timeoutId: null,
    }
  },
  methods: {
    handleInput(value) {
      this.timeoutId && clearTimeout(this.timeoutId);
      if (value !== this.lastValue) {
        this.timeoutId = setTimeout(() => {
          this.lastValue = value;
          this.$emit('input', value);
        }, this.delay);
      }
    }
  }
};
</script>
